'use strict';

var GlobalNotificationsPanelDirective = function GlobalNotificationsPanelDirective($rootScope) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/global-notifications-panel.html'),
    controller: require('../controllers/GlobalNotificationsPanelController'),
    link: function link($scope, element) {
      $rootScope.$broadcast('brush-filter:filterApplied:updateToolbar');
      element.on('rowselect', $scope.rowSelectionChanged);
      element.on('rowunselect', $scope.rowSelectionChanged);
      element.on('show.bs.modal', function () {
        $scope.resetGridPanel();
      });
      element.on('hide.bs.modal', function () {
        $scope.clearSelection();
      });
      $scope.hidePanel = function () {
        element.modal('hide');
      };
    }
  };
};
GlobalNotificationsPanelDirective.$inject = ['$rootScope'];
module.exports = GlobalNotificationsPanelDirective;